import React, { useState, useEffect, useContext } from "react";
import { auth_forgot_password } from "../../assets/images";
import { Link, useNavigate } from "react-router-dom";
import RecaptchaComponent from "../../components/RecaptchaComponent";
import { AuthServiceContext } from "../../services/auth/authService";
import { useUserContext } from "../../context/user_context";
import CustomAlert from "../../components/CustomAlert";
import Cookies from "js-cookie";

const ForgotPasswordStep2 = () => {
  const [formData, setFormData] = useState({
    info: "",
    password: "",
    confirmPassword: "",
    code: "",
    recaptchaCode: "",
  });
  const navigate = useNavigate();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const { captchaState, setCaptchaState, send } = useUserContext();
  const [errors, setErrors] = useState({});
  const { resetPassword } = useContext(AuthServiceContext);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    //console.log([name, value]);
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    const info = Cookies.get("resetPasswordInfo");
    if (!info) {
      navigate("/auth-forgot-password");
    } else {
      setFormData({ ...formData, info: info });
    }
  }, []);

  const handleResetPassword = async () => {
    const { confirmPassword, ...filteredFormData } = formData;
    const response = await resetPassword({
      ...filteredFormData,
      recaptchaCode: captchaState.token,
    });

    if (!response.success) {
      setResetCaptcha(!resetCaptcha);
      setAlertConfig({
        show: true,
        title: "შეცდომა",
        text: response.message,
        icon: "error",
        onConfirm: () => {
          setAlertConfig({ ...alertConfig, show: false });
        },
      });
    } else {
      Cookies.remove("resetPasswordInfo");
      navigate("/auth-signin");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      handleResetPassword();
    }
  };

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  const validateForm = () => {
    let formErrors = {};
    if (!formData.code || !/^\d{4}$/.test(formData.code)) {
      formErrors.code = "კოდი უნდა იყოს 4 ციფრი";
    }

    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,})/;

    if (!formData.password || !regex.test(formData.password)) {
      formErrors.password =
        "პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს, ერთ დიდ ასოს, ერთ პატარა ასოს და ერთ ციფრს";
    }

    if (formData.password !== formData.confirmPassword) {
      formErrors.confirmPassword = "პაროლები არ ემთხვევა ერთმანეთს";
    }

    if (
      captchaState.token === "" ||
      captchaState.token === null ||
      captchaState.token === undefined
    ) {
      formErrors.recaptchaCode = "მონიშნეთ reCAPTCHA";
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  return (
    <>
      <CustomAlert {...alertConfig} />
      <form onSubmit={handleSubmit}>
        <div className="flex justify-center sm:mb-6 mb-4">
          <img
            src={auth_forgot_password}
            width="240"
            height="178"
            alt="forgot password"
          />
        </div>
        <p className="sm:text-[40px]/[48px] text-[30px]/[36px] font-medium mb-2 text-center">
          პაროლის აღდგენა
        </p>
        <div className="form-control mb-5">
          <label htmlFor="code" className="form-label">
            კოდი
          </label>
          <input
            type="text"
            id="code"
            name="code"
            autoComplete="off"
            required
            placeholder="4-digit code"
            className="form-input"
            onChange={handleChange}
          />
          {errors.code && (
            <div className="text-danger text-[14px]/[20px]">{errors.code}</div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="password" className="form-label">
            პაროლი
          </label>
          <input
            type="password"
            id="password"
            name="password"
            autoComplete="off"
            required
            placeholder="8+ characters required"
            className="form-input"
            onChange={handleChange}
          />
          {errors.password && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.password}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label htmlFor="confirmPassword" className="form-label">
            გაიმეორეთ პაროლი
          </label>
          <input
            type="password"
            id="confirmPassword"
            required
            autoComplete="off"
            name="confirmPassword"
            placeholder="8+ characters required"
            className="form-input"
            onChange={handleChange}
          />
          {errors.confirmPassword && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.confirmPassword}
            </div>
          )}
        </div>
        <div className="">
          {captchaState.ask && (
            <>
              <div
                className="flex mb-20"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div className="auth-err-cont" style={{ marginTop: "10px" }}>
                  <RecaptchaComponent reset={resetCaptcha} />
                </div>
                {errors.recaptchaCode && (
                  <div className="text-danger text-[14px]/[20px]">
                    {errors.recaptchaCode}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <button
          type={"submit"}
          className="btn btn-secondary large w-full uppercase"
        >
          შემდეგი
        </button>
        <div className="text-center sm:mt-30 mt-6">
          <Link to="/auth-signin" className="text-primary">
            ავტორიზაციაზე დაბრუნება
          </Link>
        </div>
      </form>
    </>
  );
};

export default ForgotPasswordStep2;
